import { Location } from "vue-router";
import { Banner } from "@scrile/api-provider/dist/api/BannersProvider";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { SystemSettings } from "@scrile/api-provider/dist/api/SystemSettingsProvider";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { StorageItems } from "@/types";

export interface StateRoot {
  user: User | null;
  verified: UserVerificationStatus;
  socialLogin: boolean;
  authorities: string[];
  redirectPath: Location | null;
  doNotDisturb: boolean;
  userBalance: number;
  systemSettings: SystemSettings | null;
  creditCardAllowed: boolean;
  publicPaymentSystems: PaymentSystemPublic[];
  darkMode: boolean;
  nSFWUserSettings: boolean | null;
  paymentPackages: StorageItems<PaymentPackageEnum, PaymentPackage>;
  banners: Banner[] | null;
}
export const state = (): StateRoot => ({
  user: null,
  verified: UserVerificationStatus.UNVERIFIED,
  socialLogin: false,
  authorities: [],
  redirectPath: null,
  doNotDisturb: false,
  userBalance: 0,
  systemSettings: null,
  creditCardAllowed: true,
  publicPaymentSystems: [],
  darkMode: false,
  nSFWUserSettings: null,
  paymentPackages: {},
  banners: null,
});
